import type {ApiService} from '~/services/ApiService';
import type {User, UserPaginationResponseObject} from '~~/api/models';

export class OrganisationService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  async getUsers(userIds: string[] | null = null, page: number = 1, pageSize: number = 15, fields: string = 'id,displayName,email,profilePictureUrl'): Promise<UserPaginationResponseObject> {
    return this.apiService.get<UserPaginationResponseObject>('/api/organisation/users', {
      query: {
        ...(userIds && {userIds}),
        fields,
        page,
        pageSize
      }
    });
  }

  async getUser(userId: string, fields: string = 'id,displayName,email,profilePictureUrl'): Promise<User> {
    return this.apiService.get<User>(`/api/organisation/users/${userId}`, {
      query: {
        fields
      }
    });
  }

}